import React from 'react';

const Company = () => {
  return <>Company Page</>;
};

export default Company;
